export const ORDER_DETAILS_TABS = ["staffings", "monthly-overview", "details", "billing-settings", "quotas"] as const;

export type OrderDetailsTab = typeof ORDER_DETAILS_TABS[number];
